import * as React from "react";
import { Loader2 } from "lucide-react";
import { Tooltip } from "@/components/ui/tooltip";
import type { SnapshotGridFieldReviewSummary } from "@/modules/snapshots/businessReports.api";

interface Props {
  header: string;
  summary: SnapshotGridFieldReviewSummary;
}

export const ColumnReviewProgressChip: React.FC<Props> = ({ header, summary }) => (
  <Tooltip
    text={`Reviewing responses — ${summary.pending} of ${summary.total} remaining`}
    className="rounded bg-black text-xs text-white"
  >
    <span
      aria-label={`Reviewing ${header}`}
      className="inline-flex shrink-0 items-center gap-1 rounded-full bg-[#fdf0db] px-1.5 py-0.5 text-[10px] font-medium text-[#a06b1a]"
    >
      <Loader2 className="h-3 w-3 animate-spin" />
      {summary.total - summary.pending}/{summary.total}
    </span>
  </Tooltip>
);
